module.exports = __webpack_public_path__ + "img/2.8b36132a.jpg";